import {Component, EventEmitter, OnInit} from '@angular/core';
import {QuestionInfo, QuestionInfoChatItem} from '../../model/question.model';
import {BehaviorSubject} from 'rxjs';
import {ChatService} from '../chat.service';
import {UserAnswerMode} from '../../model/user-answer.mode';
import {map, switchMap} from 'rxjs/operators';
import {QuestionType} from '../../model/question-type';
import {Router} from '@angular/router';

@Component({
  selector: 'app-profile-quiz',
  templateUrl: '../quiz/quiz.component.html',
  styleUrls: ['../quiz/quiz.component.scss']
})
export class ProfileQuizComponent implements OnInit {
  answer = {};
  questions: (QuestionInfo & QuestionInfoChatItem)[] = [];
  questionsList: (QuestionInfo & QuestionInfoChatItem)[] = [];
  selectedBlockId = new BehaviorSubject<number>(null);
  currentQuestion: (QuestionInfo & QuestionInfoChatItem);
  onEditEnded = new EventEmitter<QuestionInfo & QuestionInfoChatItem>();
  editing: boolean;
  answerStatus: number = 0;
  progress: number = 0;
  questionsTotal: number = 0;
  backLink: string = "";
    categoriesList = [];
    nextBlock = '';
    checkActiveCategory;
    message;
    avatar;
    hideMenuBtn;

  checkActiveDot;
  checkDoneDot;
  checkDoneCategory;
  slideConfig;
  getDotClass;
  startQuiz;
    groupEnd;
    popupMessage;
    closePopup;
  getClass;
  blocks;
  constructor(private chatService: ChatService, private router: Router) {

  }

  ngOnInit() {

    // this.chatService.getInitialBlock().pipe(map(data => {
    //   let rez = [];
    //   Object.keys(data).forEach(key => {
    //     this.answer[key] = null;
    //     let question = <QuestionInfo & QuestionInfoChatItem> {
    //       editing: false,
    //       selected: false,
    //       answer: null,
    //       question: {
    //         answer: null,
    //         questionId: null,
    //         question: data[key],
    //         type: key == 'dob' ? QuestionType.DATE : QuestionType.INPUT_TEXT,
    //         choices: null
    //       },
    //       previousQuestionId: null
    //     };
    //     (<any> question).key = key;
    //     rez.push(question);
    //   });
    //   return rez;
    //
    // })).subscribe(rez => {
    //   this.questions = rez;
    //   this.initChat();
    // });
  }


  answerSubmitted(answer: UserAnswerMode) {
    console.log(answer);
    // if ((<any> this.currentQuestion).key == 'dob') {
    //   answer.answer = <any> new Date(answer.answer);
    // }
    // this.answer[(<any> this.currentQuestion).key] = answer.answer;
    // this.currentQuestion.answer = answer;
    // this.chatService.setProfileInfo(this.answer).subscribe(() => {
    //   if ((<any> this.questions[this.questions.length-1]).key == (<any> this.currentQuestion).key) {
    //     this.router.navigate(['']);
    //   }
    //   this.initChat();
    // });

  }

  private initChat() {
    console.log('jlswljsw');
    this.questionsList = this.questions.filter(j => j.answer);
    this.currentQuestion = this.questions.find(j => !j.answer);
    console.log(this.currentQuestion);
    this.questionsList.push(this.currentQuestion);

  }

  onEditing($event: boolean) {
    this.editing = $event;
  }

    editingEnded($event: QuestionInfo & QuestionInfoChatItem) {

    }
}
